import React from 'react';

const Button = ({ type, action, setStep, text, classname }) => {
	return type === 'button' ? (
		<button
			title={text}
			className={classname}
			onClick={() => {
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
				setStep(action);
			}}
		>
			{text}
		</button>
	) : (
		<a className={classname} href={action} title={text}>
			{text}
		</a>
	);
};

export default Button;
